module.exports = __webpack_public_path__ + "9e45f42a177aa1f9c64f807427a8463c.png";